<div class="recordings">
  <div class="bc-panel">
    <div class="recordings-header-container">
      <div class="bc-panel-header">
        <svg-icon icon="remote-access-inactive" class="bc-panel-header-icon"></svg-icon>
        <span>{{ "recordings.recordingsTitle" | translate }}</span>
        <button class="btn btn-light" (click)="navigateToWorkspace()">
          <span>{{ "recordings.backToWorkspaceButton" | translate }}</span>
        </button>
      </div>
      <div class="recording-list-header">
        <span class="recording-list-header-column">{{ "recordings.createdHeader" | translate }}</span>
        <span class="recording-list-header-column">{{ "recordings.durationHeader" | translate }}</span>
        <span class="recording-list-header-column">{{ "recordings.visitorNameHeader" | translate }}</span>
        <span class="recording-list-header-column">{{ "recordings.operatorNameHeader" | translate }}</span>
        <span class="recording-list-header-column"></span>
      </div>
    </div>
    <div class="recording-list-container">
      <div class="recording-empty-list" *ngIf="isRecordingListEmpty">
        <span>{{ "recordings.emptyRecordingList" | translate }}</span>
      </div>
      <div class="recording-list-item" *ngFor="let recording of recordingsList | appReverse">
        <span class="recording-list-item-column">{{ moment(recording.created, 'x').calendar(null, { sameElse: 'llll' }) }}</span>
        <span class="recording-list-item-column">{{ moment.duration(recording.closed - recording.created, 'milliseconds').humanize() }}</span>
        <span class="recording-list-item-column">{{ recording.visitorName }}</span>
        <span class="recording-list-item-column">{{ recording.operatorName }}</span>
        <span class="recording-list-item-column">
        <a [href]="config.current.recordingsBaseUrl + recording.rcSessionId" (click)="trackRecordingDownload()" target="_blank">{{ "recordings.downloadButton" | translate }}</a>
      </span>
      </div>
    </div>
  </div>
</div>
